import React from 'react';
import styled from 'styled-components';
import OuterLink from './OuterLink';
import withHover from '../HOC/withHover';

const BaseStyle = styled(OuterLink)`
  display: inline-block;
`;
const ButtonStyle = styled(BaseStyle)`
  --bg: var(--black);
  position: relative;
  text-align: center;
  padding: .8rem 2rem;
  background-color: var(--bg);
  border-radius: 4PX;
  > span {
    line-height: 1.6;
    color: var(--black);
    background-color: var(--bg);
    padding: 0 2.5rem;
    border-radius: 4rem;
    z-index: 2;
    position: relative;
  }
`;

let NoStyleBtn= ({children, ...props}) => {
  return (
    <BaseStyle {...props}>
      {children}
    </BaseStyle>
  );
};

let BaseBtn = ({children, ...props}) => {
  return (
    <ButtonStyle {...props}>
      {children}
    </ButtonStyle>
  );
};



export const NoStyleButton =  withHover(NoStyleBtn);
export const BaseButton =  withHover(BaseBtn);
